import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const navItems = [
    { name: t('nav.home'), path: '/' },
    { name: t('nav.about'), path: '/about' },
    { name: t('nav.services'), path: '/services' },
    { name: t('nav.faq'), path: '/faq' },
    { name: t('nav.contact'), path: '/contact' },
  ];

  const toggleLanguage = () => {
    const newLang = i18n.language === 'es' ? 'en' : 'es';
    i18n.changeLanguage(newLang);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="backdrop-blur-md bg-white/90 border-b border-pink-500/20 shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-3 text-2xl font-bold">
            <img src="./favicon.svg" alt="Arlene Tarot" className="w-12 h-12" />
            <span className="bg-primary-400 bg-clip-text text-transparent">
              Arlene Tarot
            </span>
          </Link>

          <div className="hidden md:flex items-center space-x-6">
            <div className="flex space-x-6">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-gray-600 font-medium transition-all duration-200 hover:text-pink-400 ${
                  isActive(item.path) ? 'text-pink-400 font-semibold' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
            </div>
            <button
              onClick={toggleLanguage}
              className="flex items-center space-x-2 px-4 py-2 rounded-full bg-gradient-to-r from-primary-300 to-pink-400 hover:from-primary-400 hover:to-pink-500 text-gray-600 transition-all duration-200 shadow-md hover:shadow-lg font-bold"
              title="Change language"
            >
              <Languages className="w-4 h-4" />
              <span className="text-sm font-semibold">{i18n.language.toUpperCase()}</span>
            </button>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden focus:outline-none text-gray-600 hover:text-pink-400 transition-colors"
          >
            {isOpen ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-pink-500/20">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={`block px-4 py-3 rounded-xl text-base font-medium transition-all duration-200 hover:bg-pink-50 text-gray-600 ${
                  isActive(item.path) ? 'bg-pink-50 text-pink-400 font-semibold' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
            <button
              onClick={toggleLanguage}
              className="flex items-center justify-center space-x-2 px-4 py-3 rounded-full bg-pink-600 text-gray-600 hover:bg-pink-500 transition-all duration-200 shadow-md font-bold"
            >
              <Languages className="w-5 h-5" />
              <span className="font-semibold">{i18n.language.toUpperCase()}</span>
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
